var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mx-2",style:(_vm.theme),attrs:{"loading":_vm.loading,"disabled":_vm.loading,"small":""},on:{"click":function($event){return _vm.downloadPdf()}}},[_c('v-icon',[_vm._v("mdi-download")]),(_vm.$vuetify.breakpoint.smAndUp)?_c('label',[_vm._v(_vm._s(_vm.label))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }